
"use client"

import { useEffect, useState } from "react"
import { Link, NavLink, useLocation } from "react-router-dom"
import { filterMenuByPermissions, PERMISSIONS } from "../../utils/permissions"

export default function Sidebar({ activeItem }) {
  const loginUser = JSON.parse(localStorage.getItem("user"))
  const [loginUserType, setLoginUserType] = useState(loginUser?.user_type)

  const addBodyClass = () => {
    const w = window.innerWidth
    if (w < 1250) {
      document?.body?.classList?.toggle("resize-menu")
    }
  }

  const onClickaddBodyClass = (e) => {
    e.preventDefault()
    const w = window.innerWidth
    if (w < 1250) {
      document?.body?.classList?.toggle("resize-menu")
      return
    }
    document.body.classList.add("resize-menu")
  }

  const location = useLocation()
  const [activeSubMenus, setActiveSubMenus] = useState({})

  const menuItems = [
    {
      id: "dashboard",
      title: "Dashboard",
      icon: "fa-solid fa-gauge",
      path: "/",
      hasSubmenu: false,
      permission: PERMISSIONS.DASHBOARD_VIEW,
    },
    {
      type: "separator",
      id: "master-separator",
      title: "Master",
    },
    {
      id: "library",
      title: "Library",
      icon: "fa-solid fa-book",
      path: "/library",
      hasSubmenu: false,
      permission: PERMISSIONS.LIBRARY_VIEW,
    },
    {
      id: "Tenure",
      title: "Library Tenure",
      icon: "fa-solid fa-clock",
      path: "/tenures",
      hasSubmenu: false,
      permission: PERMISSIONS.TENURE_VIEW,
    },
    {
      id: "mentors",
      title: "Mentor",
      icon: "fa-solid fa-chalkboard-user",
      path: "/mentors",
      hasSubmenu: false,
      permission: PERMISSIONS.MENTOR_VIEW,
    },
    {
      id: "ebook",
      title: "E-Book",
      icon: "fa-solid fa-tablet-alt",
      path: "/ebook",
      hasSubmenu: false,
      permission: PERMISSIONS.EBOOK_VIEW,
    },
    {
      type: "separator",
      id: "user-separator",
      title: "Users",
    },
    {
      id: "users",
      title: "Manage Users",
      icon: "fa-solid fa-users",
      path: "#",
      hasSubmenu: true,
      permission: PERMISSIONS.USER_VIEW,
      submenuItems: [
        {
          id: "student",
          title: "Users",
          icon: "fa-solid fa-user-shield",
          path: "/students",
          permission: PERMISSIONS.USER_VIEW,
        },
        {
          id: "AdminUsers",
          title: "Admin Users",
          icon: "fa-solid fa-user-shield",
          path: "/admin-users",
          permission: PERMISSIONS.USER_VIEW,
        },
        {
          id: "roles",
          title: "Roles",
          icon: "fa-solid fa-user-tag",
          path: "/roles",
          permission: PERMISSIONS.ROLE_VIEW,
        },
      ],
    },
    {
      type: "separator",
      id: "mock-separator",
      title: "Mocks",
    },
    {
      id: "organization",
      title: "Organizations",
      icon: "fa-solid fa-building",
      path: "/organizations",
      hasSubmenu: false,
      permission: PERMISSIONS.ORGANIZATION_VIEW,
    },
    {
      id: "section",
      title: "Sections",
      icon: "fa-solid fa-layer-group",
      path: "/sections",
      hasSubmenu: false,
      permission: PERMISSIONS.SECTION_VIEW,
    },
    {
      id: "subject",
      title: "Subjects",
      icon: "fa-solid fa-book-open-reader",
      path: "/subjects",
      hasSubmenu: false,
      permission: PERMISSIONS.SUBJECT_VIEW,
    },
    {
      id: "topic",
      title: "Topics",
      icon: "fa-solid fa-list",
      path: "/topics",
      hasSubmenu: false,
      permission: PERMISSIONS.TOPIC_VIEW,
    },
    {
      id: "subTopic",
      title: "Sub Topics",
      icon: "fa-solid fa-list-ul",
      path: "/subtopics",
      hasSubmenu: false,
      permission: PERMISSIONS.SUBTOPIC_VIEW,
    },
    {
      id: "exam",
      title: "Exams",
      icon: "fa-solid fa-file-circle-question",
      path: "/exams",
      hasSubmenu: false,
      permission: PERMISSIONS.EXAM_VIEW,
    },
    {
      id: "package",
      title: "Packages",
      icon: "fa-solid fa-file-circle-question",
      path: "/packages",
      hasSubmenu: false,
      permission: PERMISSIONS.PACKAGE_VIEW,
    },
    {
      id: "question",
      title: "Questions",
      icon: "fa-solid fa-question-circle",
      path: "/questions",
      hasSubmenu: false,
      permission: PERMISSIONS.QUESTION_VIEW,
    },
    {
      id: "language",
      title: "Languages",
      icon: "fa-solid fa-question-circle",
      path: "/languages",
      hasSubmenu: false,
      permission: PERMISSIONS.LANGUAGE_VIEW,
    },
    {
      type: "separator",
      id: "finance-separator",
      title: "Finance",
    },
    {
      id: "orders",
      title: "Manage Orders",
      icon: "fa-solid fa-cart-shopping",
      path: "/orders",
      hasSubmenu: true,
      permission: PERMISSIONS.ORDER_VIEW,
      submenuItems: [
        {
          id: "libraryBookings",
          title: "Library Bookings",
          icon: "fa-solid fa-scroll",
          path: "/orders/library-bookings",
          hasSubmenu: false,
          permission: PERMISSIONS.LIBRARY_BOOKING_VIEW,
        },
        {
          id: "packagePurchase",
          title: "Packages Order",
          icon: "fa-solid fa-box",
          path: "/orders/package-purchase",
          hasSubmenu: false,
          permission: PERMISSIONS.PACKAGE_PURCHASE_VIEW,
        },
        {
          id: "ebookPurchase",
          title: "Ebook Purchase",
          icon: "fa-solid fa fa-book-open ",
          path: "/orders/ebook-purchase",
          hasSubmenu: false,
          permission: PERMISSIONS.EBOOK_PURCHASE_VIEW,
        },
      ],
    },
    {
      id: "reports",
      title: "Manage Reports",
      icon: "fa-solid fa-chart-bar",
      path: "/reports",
      hasSubmenu: true,
      permission: PERMISSIONS.REPORT_VIEW,
      submenuItems: [
        {
          id: "LibraryReport",
          title: "Library Report",
          icon: "fa-solid fa-scroll",
          path: "/reports/library-report",
          hasSubmenu: false,
          permission: PERMISSIONS.LIBRARY_REPORT_VIEW,
        },
        {
          id: "PackageReport",
          title: "Mock Test Report",
          icon: "fa-solid fa-box",
          path: "/reports/package-report",
          hasSubmenu: false,
          permission: PERMISSIONS.PACKAGE_REPORT_VIEW,
        },
        {
          id: "EbookReport",
          title: "Ebook Report",
          icon: "fa-solid fa fa-book-open ",
          path: "/reports/ebook-report",
          hasSubmenu: false,
          permission: PERMISSIONS.EBOOK_REPORT_VIEW,
        },
      ],
    },
    {
      id: "referral",
      title: "Manage Referrals",
      icon: "fa-solid fa-cart-shopping",
      path: "/referrals",
      hasSubmenu: false,
      permission: PERMISSIONS.REFERRAL_VIEW,
    },
    {
      id: "coupon",
      title: "Manage Coupons",
      icon: "fa-solid fa-cart-shopping",
      path: "/coupons",
      hasSubmenu: true,
      permission: PERMISSIONS.COUPON_VIEW,
      submenuItems: [
        {
          id: "couponList",
          title: "Coupons",
          icon: "fa-solid fa-ticket",
          path: "/coupons",
          hasSubmenu: false,
          permission: PERMISSIONS.COUPON_VIEW,
        },
        {
          id: "couponAdd",
          title: "Add Coupon",
          icon: "fa-solid fa-ticket",
          path: "/coupons/add",
          hasSubmenu: false,
          permission: PERMISSIONS.COUPON_CREATE,
        },
      ],
    },

    {
      type: "separator",
      id: "setting-separator",
      title: "Setting",
    },
    {
      id: "banner",
      title: "Banner",
      icon: "fa-solid fa-layer-group",
      path: "/banner",
      hasSubmenu: false,
      permission: PERMISSIONS.BANNER_VIEW,
    },
    {
      id: "settings",
      title: "Settings",
      icon: "fa-solid fa-cog",
      path: "/settings",
      hasSubmenu: false,
      permission: PERMISSIONS.SETTINGS_VIEW,
    },
    {
      id: "testimonial",
      title: "Testimonials",
      icon: "fa-solid fa-cog",
      path: "/testimonials",
      hasSubmenu: false,
      permission: PERMISSIONS.TESTIMONIAL_VIEW,
    },
    {
      id: "faqs",
      title: "FAQs",
      icon: "fa-solid fa-circle-question",
      path: "/faqs",
      hasSubmenu: false,
      permission: PERMISSIONS.FAQ_VIEW,
    },
    {
      id: "contactQueries",
      title: "Contact Queries",
      icon: "fa-solid fa-envelope-open-text",
      path: "/contact-queries",
      hasSubmenu: false,
      permission: PERMISSIONS.CONTACT_QUERY_VIEW,
    },
  ]

  const [filteredMenuItems, setFilteredMenuItems] = useState([])

  useEffect(() => {
    const filtered = filterMenuByPermissions(menuItems)
    setFilteredMenuItems(filtered)
  }, [])

  useEffect(() => {
    const subMenuStates = {}
    filteredMenuItems.forEach((item) => {
      if (item.hasSubmenu && item.submenuItems) {
        const isActive = item.submenuItems.some((subItem) => location.pathname === subItem.path)
        if (isActive) {
          subMenuStates[item.id] = true
        }
      }
    })

    setActiveSubMenus(subMenuStates)
  }, [location.pathname, filteredMenuItems])

  const handleToggleSubmenu = (menuKey) => {
    setActiveSubMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }))
  }

  const isMenuActive = (item) => {
    if (!item.hasSubmenu) {
      return location.pathname === item.path
    }

    return item.submenuItems.some((subItem) => location.pathname === subItem.path)
  }

  return (
    <>
      <div className="dash-menu">
        <div className="dashbord-logo">
          <Link to="" className="navbar-brand d-flex align-items-center gap-2">
            <img src="/Pidigihub_Logo.png" width={50} height={50} alt="Logo" />
            <h2 className="text-white fw-bold">Pidigihub</h2>
          </Link>
          <button className="toggle cross-icon" onClick={onClickaddBodyClass}>
            <i className="fa fa-chevron-left" />
          </button>
        </div>
        <div className="dash-menu-bar">
          <nav className="nav-menu navbar navbar-expand-lg" id="navbar">
            <ul>
              {filteredMenuItems.map((item) => {
                if (item.type === "separator") {
                  return (
                    <li
                      key={item.id}
                      className="menu-header"
                      style={{
                        fontSize: "13px",
                        padding: "10px 0px",
                      }}
                    >
                      {item.title}
                    </li>
                  )
                }

                return (
                  <li
                    key={item.id}
                    className={`nav-item ${item.hasSubmenu ? "has-submenu" : ""} ${item.hasSubmenu && activeSubMenus[item.id] ? "show" : ""
                      }`}
                    onClick={item.hasSubmenu ? undefined : addBodyClass}
                  >
                    {item.hasSubmenu ? (
                      <>
                        <div
                          className={`nav-link ${isMenuActive(item) ? "active" : ""}`}
                          onClick={() => handleToggleSubmenu(item.id)}
                        >
                          <span className={`fa ${item.icon} me-2 icon`} /> {item.title}
                          <span className="d-inline-block ms-auto">
                            <i className={`fa fa-angle-${activeSubMenus[item.id] ? "up" : "down"} nav-link-arrow`} />
                          </span>
                        </div>

                        {activeSubMenus[item.id] && (
                          <ul className="sub_menu">
                            {item.submenuItems.map((subItem) => (
                              <li
                                key={subItem.id}
                                className={`nav-item ${location.pathname === subItem.path ? "active" : ""}`}
                              >
                                <NavLink to={subItem.path} className="submenu-link" onClick={addBodyClass}>
                                  <span className={`fa ${subItem.icon} me-2 icon`} /> {subItem.title}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        )}
                      </>
                    ) : (
                      <NavLink to={item.path} className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
                        <span className={`fa ${item.icon} me-2 icon`} />
                        {item.title}
                      </NavLink>
                    )}
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </div>

      {/* CSS for submenus */}
      <style jsx="true">{`
        .dash-menu .nav-menu .nav-item.has-submenu .nav-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
        }

        .dash-menu .nav-menu .nav-item.has-submenu.show .nav-link {
          background-color: #fff;
          color: #2d3748;
          box-shadow: 0px 3.5px 5.5px 0px #00000005;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }

        .dash-menu .nav-menu .nav-item.has-submenu.show .nav-link span.icon {
          background-color: #111727;
          color: #fff;
        }

        .sub_menu {
          background-color: #fff;
          color: #2d3748;
          padding: 0;
          margin: 0;
          margin-bottom: 10px;
          border-bottom-left-radius: 15px;
          border-bottom-right-radius: 15px;
          overflow: hidden;
          box-shadow: 0px 3.5px 5.5px 0px #00000005;
        }

        .sub_menu .nav-item {
          margin-bottom: 0;
          padding: 10px 15px;
          overflow: hidden;
        }

        .sub_menu .nav-item.active {
          background-color: #FF693D;
          border: 1px solid #fff;
          border-radius: inherit;
          box-shadow: 1px 2px 6px #ccc;
          margin-bottom: 0;
        }

        .sub_menu .nav-item .submenu-link {
          display: flex;
          align-items: center;
          color: #2d3748;
          font-size: 14px;
          font-weight: 500;
          text-transform: uppercase;
        }

        .sub_menu .nav-item.active .submenu-link {
          color: #fff;
        }

        .sub_menu .nav-item .submenu-link span.icon {
          display: inline-block;
          height: 30px;
          width: 30px;
          line-height: 30px;
          text-align: center;
          background-color: #111727;
          color: #fff;
          border-radius: 10px;
          margin-right: 8px;
        }

        .sub_menu .nav-item.active .submenu-link span.icon {
          background-color: #fff;
          color: #111727;
        }
        .sub_menu .nav-item:hover {
          background: #FFBD0C;
        }

        .menu-header{
        color: #fff;
        border-bottom: 1px dashed #E2EBEC;
        font-family:"poppins";
        padding-bottom:5px;
        margin-bottom:5px;
        }
      `}</style>
    </>
  )
}
